import { useEffect, useState } from 'react';
import apiClient from './apiClient';

function useFetch(url, fetch) {
  const [data, setData] = useState();
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [errorLoader, setErrorLoader] = useState(false);

  useEffect(() => {
    let isMounted = true;
    apiClient()
      .get(url)
      .then(res => {
        if (isMounted) {
          setData(() => res);
          setLoaded(() => true);
        }
      })
      .catch(e => {
        setError(() => e);
        setErrorLoader(() => true);
      });
    return () => {
      isMounted = false;
    };
  }, [url, fetch]);

  return {
    data,
    loaded,
    error,
    errorLoader,
  };
}

export default useFetch;
